// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortened-select {
    width: 50%;    
    border: solid 1px #e5eaed !important;
    border-radius: 5px !important;
    height:40px !important;
    margin-right:10px;
}

  .sort-fields-dropdown-wrapper{
    margin-top:20px;
  }
  

  .order-select {
    width: 30%; /* Width for the sort order dropdown */
  }
  
  .sort-fields-dropdown-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px; /* Space between each row */
  }
  
  .sort-fields-dropdown-wrapper mat-icon-button {
    margin-left: 8px; /* Space between dropdown and delete button */
  }
  
  .sort-fields-dropdown-wrapper .mat-icon {
    color: #f44336; /* Optional: Red color for delete icon */
  }

.sorting-tab-icon-close{
    cursor:pointer;
}


`, "",{"version":3,"sources":["webpack://./src/app/components/controls/dialogs/sem-view-settings-dialog/sem-view-settings-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,oCAAoC;IACpC,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;AACrB;;EAEE;IACE,eAAe;EACjB;;;EAGA;IACE,UAAU,EAAE,sCAAsC;EACpD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;IACE,gBAAgB,EAAE,6CAA6C;EACjE;;EAEA;IACE,cAAc,EAAE,wCAAwC;EAC1D;;AAEF;IACI,cAAc;AAClB","sourcesContent":[".shortened-select {\r\n    width: 50%;    \r\n    border: solid 1px #e5eaed !important;\r\n    border-radius: 5px !important;\r\n    height:40px !important;\r\n    margin-right:10px;\r\n}\r\n\r\n  .sort-fields-dropdown-wrapper{\r\n    margin-top:20px;\r\n  }\r\n  \r\n\r\n  .order-select {\r\n    width: 30%; /* Width for the sort order dropdown */\r\n  }\r\n  \r\n  .sort-fields-dropdown-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px; /* Space between each row */\r\n  }\r\n  \r\n  .sort-fields-dropdown-wrapper mat-icon-button {\r\n    margin-left: 8px; /* Space between dropdown and delete button */\r\n  }\r\n  \r\n  .sort-fields-dropdown-wrapper .mat-icon {\r\n    color: #f44336; /* Optional: Red color for delete icon */\r\n  }\r\n\r\n.sorting-tab-icon-close{\r\n    cursor:pointer;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
